var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40.218c-11.028 0-20-8.968-20-19.99C0 9.193 8.972.217 20 .217s20 8.976 20 20.01c0 11.022-8.972 19.99-20 19.99zm-10.028-34a17.33 17.33 0 0 0-4.775 5.418A17.255 17.255 0 0 0 3 20.064c0 9.459 7.626 17.154 17 17.154 9.373 0 17-7.695 17-17.154 0-2.954-.76-5.868-2.196-8.428a17.316 17.316 0 0 0-4.773-5.414c-.236 2.954-4.558 5.232-10.032 5.232-5.473 0-9.794-2.28-10.027-5.235zm10.027-4c-1.899 0-3.7.416-5.073 1.17C13.72 4.051 13 4.923 13 5.722c0 .798.72 1.669 1.925 2.33 1.373.752 3.174 1.167 5.073 1.167 1.9 0 3.702-.415 5.075-1.168C26.28 7.391 27 6.52 27 5.722c0-.798-.72-1.671-1.927-2.334-1.373-.754-3.176-1.17-5.075-1.17z",
    fill: "#6238F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "9n33uxqm3a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40.218c-11.028 0-20-8.968-20-19.99C0 9.193 8.972.217 20 .217s20 8.976 20 20.01c0 11.022-8.972 19.99-20 19.99zm-10.028-34a17.33 17.33 0 0 0-4.775 5.418A17.255 17.255 0 0 0 3 20.064c0 9.459 7.626 17.154 17 17.154 9.373 0 17-7.695 17-17.154 0-2.954-.76-5.868-2.196-8.428a17.316 17.316 0 0 0-4.773-5.414c-.236 2.954-4.558 5.232-10.032 5.232-5.473 0-9.794-2.28-10.027-5.235zm10.027-4c-1.899 0-3.7.416-5.073 1.17C13.72 4.051 13 4.923 13 5.722c0 .798.72 1.669 1.925 2.33 1.373.752 3.174 1.167 5.073 1.167 1.9 0 3.702-.415 5.075-1.168C26.28 7.391 27 6.52 27 5.722c0-.798-.72-1.671-1.927-2.334-1.373-.754-3.176-1.17-5.075-1.17z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.c7c0e11247034f44f941a05612cf5ba4.svg";
export { ForwardRef as ReactComponent };